import React, { Component, useState } from 'react'
import { Card, Empty, Button, Icon, Modal, notification, Select } from 'antd'
import { connect } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import moment from 'moment'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { getConferenceInterests, deleteConferenceInterest, exportConferenceInterestsFxn } from './actions'
import { apiUrl } from '../../settings'
import AddNoteForConferenceInterest from './drawers/AddNoteForConferenceInterest'

const regExpFilters = ['firstName', 'lastName', 'email', 'phone', 'department', 'designation']

const RenderMessage = props => {
  let { text } = props
  let [hideV, setHideV] = useState(true)
  return (
    text && (
      <div>
        <div className={hideV ? 'appCommentDotsReplace' : ''}>
          {text ? text : ''}
        </div>
        {text.length && text.length > 100 ? (
          <div className={'alignRight'}>
            {hideV ? (
              <a
                onClick={() => {
                  setHideV(false)
                }}>
                Show More
              </a>
            ) : (
              <a
                onClick={() => {
                  setHideV(true)
                }}>
                Show Less
              </a>
            )}
          </div>
        ) : (
          ''
        )}
      </div>
    )
  )
}


class ConferenceInterest extends Component {
  constructor(props) {
    super(props)
    this.table = React.createRef()
    this.state = {
      filteredUsers: [],
      selectedEvent: '',
      visibleAddNote: false,
      onlineSubmissionId: ''
    }
  }

  loadData = params => {
    return new Promise(async resolve => {
      let { dispatch } = this.props
      let apiParams = {
        sortField: 'createdAt',
        sortOrder: 'descend',
        ...params
      }
      let { selectedEvent } = params.eventName ? { selectedEvent: params.eventName[0] } : this.state
      if (selectedEvent === '__unknown__') {
        apiParams.eventName = ''
      } else if (selectedEvent) {
        apiParams.eventName = selectedEvent
      }
      let data = await dispatch(getConferenceInterests({ ...apiParams, regExFilters: regExpFilters }))
      this.setState({
        filteredUsers: data.data
      })
      resolve(data)
    })
  }

  onDelete = id => {
    Modal.confirm({
      title: 'Are you sure you want to delete this record?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: async () => {
        let { dispatch } = this.props
        let result = await dispatch(deleteConferenceInterest(id))
        if (result && result.success) {
          notification.success({ message: result.message || 'Deleted successfully' })
          this.table.current.reload()
        } else {
          notification.error({ message: result.message || 'Error deleting record' })
        }
      }
    })
  }

  exportExcel = async () => {
    let { dispatch } = this.props
    try {
      // Fetch ALL records without pagination limit for export
      let allData = await dispatch(getConferenceInterests({
        sortField: 'createdAt',
        sortOrder: 'descend',
        count: 10000,
        page: 1,
        regExFilters: regExpFilters
      }))

      let records = allData && allData.data ? allData.data : []

      if (records.length > 0) {
        let resp = await dispatch(exportConferenceInterestsFxn({ data: records }))
        if (resp && resp.success) {
          notification.success({ message: `Export successful! ${records.length} records downloaded.` })
          window.open(`${apiUrl}${resp.fileName}`, 'Download')
        } else {
          notification.error({ message: 'Export failed: ' + (resp.message || 'Unknown error') })
        }
      } else {
        notification.warning({ message: 'No data available to export' })
      }
    } catch (err) {
      console.error('Export Error:', err)
      notification.error({ message: 'Export failed. Please try again.' })
    }
  }

  render() {
    const columns = [
      {
        title: 'Sr. No',
        key: '_id',
        sorter: true,
        dataIndex: 'firstName',
        width: 80,
        render: (text, record, index) => index + 1
      },
      {
        title: 'Date',
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: true,
        defaultSortOrder: 'descend',
        width: 120,
        render: text => text ? moment(text).format('DD MMM, YYYY') : 'N/A'
      },
      // {
      //   title: 'Event Name',
      //   dataIndex: 'eventName',
      //   key: 'eventName',
      //   width: 220,
      //   filters: this.state.filteredUsers && this.state.filteredUsers.length > 0 ?
      //     Array.from(new Set(this.state.filteredUsers.map(u => u.eventName).filter(Boolean)))
      //       .map(name => ({ text: name, value: name }))
      //     : [],
      //   filterMultiple: false,
      //   render: text => text || 'General / Unknown'
      // },
      // {
      //   title: 'Event ID',
      //   dataIndex: 'eventId',
      //   key: 'eventId',
      //   width: 130,
      //   render: text => text || '-'
      // },
      {
        title: 'First Name',
        key: 'firstName',
        sorter: true,
        dataIndex: 'firstName',
        searchTextName: 'firstName',
        filterByRegex: true,
        width: 150,
        render: (text, record) => `${record.firstName || ''}`.trim() || 'N/A'
      },
      {
        title: 'Last Name',
        key: 'lastName',
        sorter: true,
        dataIndex: 'lastName',
        searchTextName: 'lastName',
        filterByRegex: true,
        width: 150,
        render: (text, record) => `${record.lastName || ''}`.trim() || 'N/A'
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        sorter: true,
        searchTextName: 'email',
        filterByRegex: true,
        width: 170
      },
      {
        title: 'Phone No.',
        dataIndex: 'phoneNo',
        key: 'phoneNo',
        sorter: true,
        searchTextName: 'phoneNo',
        filterByRegex: true,
        width: 130
      },
      {
        title: 'Participant As',
        dataIndex: 'participantAs',
        key: 'participantAs',
        sorter: true,
        searchTextName: 'participantAs',
        filterByRegex: true,
        width: 150,
        render: text => text || 'N/A'
      },
      {
        title: 'Message',
        dataIndex: 'message',
        key: 'message',
        sorter: true,
        searchTextName: 'message',
        filterByRegex: true,
        width: 150,
        render: text => text || 'N/A'
      },
      // {
      //   title: 'Message',
      //   dataIndex: 'message',
      //   key: 'message',
      //   width: 320,
      //   render: (text) => (
      //     <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
      //       <RenderMessage text={text} />
      //     </div>
      //   )
      // },
      // {
      //   title: 'Action',
      //   key: 'operation',
      //   width: 120,
      //   render: (text, record) => (
      //     <div style={{ display: 'flex', gap: '8px' }}>
      //       <Button type='danger' shape='circle' onClick={() => this.onDelete(record._id)}>
      //         <Icon type='delete' />
      //       </Button>
      //       <Button
      //         type='primary'
      //         shape='circle'
      //         onClick={() => {
      //           this.setState({
      //             visibleAddNote: true,
      //             onlineSubmissionId: record._id
      //           })
      //         }}>
      //         <Icon type='form' />
      //       </Button>
      //     </div>
      //   )
      // }

      {
        title: 'Action',
        key: 'operation',
        align: 'center',
        width: 120,
        render: (text, record) => (
          <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
            <Button type='danger' shape='circle' onClick={() => this.onDelete(record._id)}>
              <Icon type='delete' />
            </Button>
            <Button
              type='primary'
              shape='circle'
              onClick={() => {
                this.setState({
                  visibleAddNote: true,
                  onlineSubmissionId: record._id
                })
              }}>
              <Icon type='form' />
            </Button>
          </div>
        )
      }
    ]

    return (
      <PageHeaderWrapper
        title={'Conference Interests'}
        content={[
          <Button
            key='1'
            type='primary'
            onClick={() => {
              this.exportExcel()
            }}>
            <Icon type={'file'} />
            Export
          </Button>
        ]}
      >
        <Card bordered>
          <TableComp
            ref={this.table}
            extraProps={{ scroll: { x: 1200 } }}
            columns={columns}
            apiRequest={this.loadData}
            locale={{ emptyText: <Empty description='No data found' /> }}
          />
        </Card>
        {this.state.visibleAddNote ? (
          <AddNoteForConferenceInterest
            visible={this.state.visibleAddNote}
            conferenceInterestId={this.state.onlineSubmissionId}
            onClose={() => {
              this.setState({ visibleAddNote: false })
              this.table.current.reload()
            }}
          />
        ) : null}
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global }) => ({})

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(ConferenceInterest)
